import { FC, ReactNode } from 'react';
import { NavLink as BaseLink } from 'react-router-dom';

import { Link, LinkProps, rem } from '@bonusly/design-system';

import { useIsRecognize } from '../../../../hooks/use-is-recognize';

export interface LinkButtonProps extends LinkProps {
	_active?: object;
	_disabled?: object;
	_focusVisible?: object;
	_hover?: object;
	backgroundColor?: string;
	children?: ReactNode;
	color?: string;
	fontSize?: object | string;
	height?: number | object | string;
	padding?: number | string;
	to: string;
	width?: number | string;
	onClick?: VoidFunction;
}

export const LinkButton: FC<LinkButtonProps> = ({
	_active,
	_disabled,
	_focusVisible,
	_hover,
	backgroundColor,
	children,
	color,
	fontSize,
	height,
	padding,
	to,
	width,
	onClick,
	...rest
}) => {
	const isRecognize = useIsRecognize();
	return (
		<Link
			_active={_active || { backgroundColor: 'blue.500', color: 'blue.700' }}
			_disabled={_disabled || { backgroundColor: 'grayAlpha.50', color: 'gray.100' }}
			_focusVisible={
				_focusVisible || {
					outlineColor: 'border.focus',
					outlineStyle: 'solid',
					outlineWidth: '2px',
				}
			}
			_hover={_hover || { backgroundColor: 'blue.500', color: 'blue.700' }}
			alignItems="center"
			as={BaseLink}
			backgroundColor={backgroundColor || 'blue.500'}
			borderRadius="md"
			color={color || 'blue.600'}
			display="flex"
			fontSize={fontSize || { base: 'md', xs: 'lg' }}
			fontWeight="medium"
			height={height || { base: 10, xs: rem(44) }}
			justifyContent="center"
			letterSpacing="-0.013em"
			lineHeight={6}
			padding={padding || rem(10)}
			textDecoration="none"
			to={to}
			transitionDuration="normal"
			transitionProperty="common"
			width={width || 'full'}
			reloadDocument={isRecognize}
			onClick={onClick}
			{...rest}
		>
			{children}
		</Link>
	);
};
